import { FunctionComponent } from 'react';
import styles from './FoodProvisioner.module.scss';
import { useMasterData } from 'hooks';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup';

interface FoodProvisionerProps {
    onProvisionerChange: (provisioner: number) => void;
    selectedProvisioner: number;
}

const FoodProvisioner: FunctionComponent<FoodProvisionerProps> = props => {
    const foodProvisionTypes = useMasterData().foodProvisionTypes;

    const handleProvisionerChange = (provisioner: number) => {
        props.onProvisionerChange(provisioner);
    };

    const getFormattedOptions = () => {
        return foodProvisionTypes.map(provisioner => ({
            value: provisioner.id,
            inlineLabel: provisioner.name,
            description: provisioner.description
        }));
    };

    return (
        <div className={styles.foodProvisionerContainer}>
            <RadioGroup
                value={props.selectedProvisioner}
                options={getFormattedOptions()}
                className={styles.radioGroup}
                onChange={handleProvisionerChange}
            />
        </div>
    );
};

export default FoodProvisioner;
